import { useAtomValue } from "jotai";
import { FC, ReactNode } from "react";
import { isMediaShareModeAtom } from "../state";
import { usePictureInPicture } from "../usePictureInPicture";
import { MediaShareLayoutWrapper as MediaShareLayout } from "./MediaShareLayout";
import {
  RemoteParticipantGridWrapper as RemoteAudioVideoGrid,
  RemoteParticipantGridProps,
} from "./RemoteParticipantGrid";

export function SessionGrid({
  thumbnail,
  remoteParticipantComponent: RemoteParticipantComponent,
  whiteboardComponent: WhiteboardComponent,
}: {
  thumbnail: ReactNode;
  whiteboardComponent: FC;
} & Pick<RemoteParticipantGridProps, "remoteParticipantComponent">) {
  const isMediaShareMode = useAtomValue(isMediaShareModeAtom);

  usePictureInPicture();

  return isMediaShareMode ? (
    <MediaShareLayout
      remoteParticipantComponent={RemoteParticipantComponent}
      thumbnail={thumbnail}
      whiteboardComponent={WhiteboardComponent}
    />
  ) : (
    <RemoteAudioVideoGrid
      remoteParticipantComponent={RemoteParticipantComponent}
    />
  );
}
